import { Bootstrapper } from "@/app/Bootstrapper.tsx";
import { AppLoading } from "@/components/ui/app-loading/AppLoading.tsx";
import { TimeZoneContext, useEnvironmentVariables, useGetCurrentUserSuspenseQuery } from "@workleap-ai/shared";
import { Outlet } from "react-router";

export const AuthenticationBoundary = () => {
    const { data: { isAssigned, timeZone } } = useGetCurrentUserSuspenseQuery();
    const { managementAppBaseUrl } = useEnvironmentVariables();

    // If the user is not assigned to Workleap AI, redirect to the management app
    if (!isAssigned) {
        window.location.href = managementAppBaseUrl;

        return <AppLoading />;
    }

    return (
        <TimeZoneContext.Provider value={timeZone}>
            <Bootstrapper>
                <Outlet />
            </Bootstrapper>
        </TimeZoneContext.Provider>
    );
};
